/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_RetractedInputs */

const cs_enum_retracted = /** @type {(inputs: Enum_RetractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staženo`)
};

const en_enum_retracted = /** @type {(inputs: Enum_RetractedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retracted`)
};

/**
* | output |
* | --- |
* | "Retracted" |
*
* @param {Enum_RetractedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_retracted = /** @type {((inputs?: Enum_RetractedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_RetractedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_retracted(inputs)
	return cs_enum_retracted(inputs)
});